class MemoryStorageAdapter {
    data = new Map();
    getItem(key) {
        return this.data.get(key) ?? null;
    }
    setItem(key, value) {
        this.data.set(key, value);
    }
    removeItem(key) {
        this.data.delete(key);
    }
}
export function getDefaultStorage() {
    if (typeof window !== "undefined" && window.localStorage) {
        return window.localStorage;
    }
    return new MemoryStorageAdapter();
}
